import { render, staticRenderFns } from "./image-title-description-button.vue?vue&type=template&id=5ab64858&scoped=true"
import script from "./image-title-description-button.vue?vue&type=script&lang=js"
export * from "./image-title-description-button.vue?vue&type=script&lang=js"
import style0 from "./image-title-description-button.vue?vue&type=style&index=0&id=5ab64858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab64858",
  null
  
)

export default component.exports